<script>
    import {Constans} from "../lib/Constants";
    import {cancelSubscription, applyCancellationDiscount} from "../lib/ApiRequests.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import {_} from '../lib/i18n';

    export let params;
    export let show = false;
    export let discountedPrice = 0;
    export let discountValue = 0;

    export let showSubscriptionSettings = true;

    function closeModal() {
        show = false;
    }

    export let showNextModal = false;
    function toggleNextModal() {
        show = false;
        showNextModal = true;
    }

    async function applyDiscount() {
        if (applyDiscountLoading) return;

        applyDiscountLoading = true;
        const response = await applyCancellationDiscount();
        if (response.status === 'ok') {
            try {
                if (params.disableSpyWeekDiscount instanceof Function) {
                    params.disableSpyWeekDiscount();
                }
            } catch (err) { console.error(err) }
            closeModal();
        }
        applyDiscountLoading = false;
    }

    async function initCancelSubscription() {
        if (cancellationLoading) return;

        cancellationLoading = true;
        const response = await cancelSubscription();
        if (response.status === 'ok') {
            try {
                if (params.changeSpySubscriptionStatus instanceof Function) {
                    params.changeSpySubscriptionStatus(Constans.spySubscriptionStatuses.CANCELED);
                }
            } catch (err) {
                console.error(err)
            }
            showSubscriptionSettings = false;
            closeModal();
        }
        cancellationLoading = false;
    }

    let cancellationLoading = false;
    let applyDiscountLoading = false;
</script>

<section class={`modal ${show ? '' : 'hide'}`}>
    <div class="modal__fade"></div>
    <div class="modal-body modal-body_subscription-cancel">
        <div on:click={closeModal} class="modal-body__close-icon" on:click={closeModal}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.06665 7.4668L15.5333 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.5333 7.4668L8.06666 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div class="modal-body__header modal-body__header_green">
            <div class="modal-body__header-icon modal-body__header-icon_red">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3.60059" y="6.40039" width="16.8" height="12.1333" rx="2" stroke="#57A41B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.60059 10.1348H19.9339" stroke="#57A41B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.33398 14.8008H9.20065" stroke="#57A41B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <h4 class="modal-body__header-title">{$_('cancelSubscriptionModal3.title')}</h4>
        </div>
        <div class="modal-body__content-wrapper">
            <p class="modal-body__content-text">{@html $_('cancelSubscriptionModal3.description', {
                values: { discountValue }
            })}</p>
            <p class="modal-body__content-text">{$_('cancelSubscriptionModal3.descriptionPart2', {
                values: { discountedPrice }
            })}</p>
        </div>
        <div class="modal-body__controls-wrapper">
            <button on:click={applyDiscount} class="button button_shadow modal-body__btn-main">
                <LoadingIcon show={applyDiscountLoading} `height="16" width="16"` color="#fff" />
                {$_('cancelSubscriptionModal3.getDiscountLabel')} {discountValue}%
            </button>
            <button on:click={initCancelSubscription} class="button button_textual modal-body__btn-secondary">
                <LoadingIcon show={cancellationLoading} height="16" width="16" />
                {$_('cancelSubscriptionModal3.cancelSubscription')}
            </button>
        </div>
    </div>
</section>

<style>
    .hide {
        display: none;
    }
</style>